// mimics the 'env_script_tag' in app/views/layouts/works.html.erb
type EnvVarType = {
  APP_NAME?: string;
  APP_VERSION?: string;
  RAILS_ENV?: string;
  SENTRY_APP_NAME?: string;
  SENTRY_DSN?: string;
  SENTRY_ENV?: string;
  SENTRY_REPLAY_ENABLED?: string;
  WORKS_FULLSTORY_ORG_ID?: string;
  WORKS_INTERCOM_APP_ID?: string;
};

type WindowType = Window & {
  __ENV__: EnvVarType;
};

export const ENV_VARS = (window as unknown as WindowType).__ENV__ || {};
